import axios from 'axios';
import { all, takeLatest, select, call, put } from 'redux-saga/effects';
import { getProfileOwnerUser } from '../selectors/users';
import { API_BASE_PATH } from '../../constants';
import {
  fetchProfileOwnerGiveState,
  fetchProfileOwnerGiveStateSuccess,
  fetchProfileOwnerGiveStateFailure,
} from '../actions/profileOwner';

function fetchFromApi(requestUrl, params) {
  return axios
    .get(`${API_BASE_PATH}/${requestUrl}`, { params })
    .catch(response => false);
}

export function* fetchProfileOwnerGiveStateSaga() {
  const profileOwnerUser = yield select(getProfileOwnerUser);

  const result = yield call(fetchFromApi, 'give_menu/status', {
    username: profileOwnerUser.username,
  });

  const data = result.data;

  if (!result.data) {
    yield put(fetchProfileOwnerGiveStateFailure());
  }

  yield put(
    fetchProfileOwnerGiveStateSuccess({
      canBeGivenLlama: data.canGiveLlama,
      canBeGivenCake: data.canGiveCake,
      canBeGivenCore: data.canGiveCore,
    })
  );
  return;
}

export default function* rootFeedSaga() {
  yield all([
    takeLatest(fetchProfileOwnerGiveState, fetchProfileOwnerGiveStateSaga),
  ]);
}
